import { render, staticRenderFns } from "./TrackShippingDialog.vue?vue&type=template&id=85b08cd2"
import script from "./TrackShippingDialog.vue?vue&type=script&lang=ts"
export * from "./TrackShippingDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports